var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.56 9.05H0.44C0.196625 9.05 0 9.22875 0 9.45V9.9C0 9.955 0.0495 10 0.11 10H10.89C10.9505 10 11 9.955 11 9.9V9.45C11 9.22875 10.8034 9.05 10.56 9.05ZM2.00338 8C2.03087 8 2.05838 7.9975 2.08588 7.99375L4.39862 7.625C4.42613 7.62 4.45225 7.60875 4.4715 7.59L10.3001 2.29125C10.3129 2.27969 10.323 2.26595 10.3299 2.25083C10.3368 2.23571 10.3403 2.2195 10.3403 2.20312C10.3403 2.18675 10.3368 2.17054 10.3299 2.15542C10.323 2.1403 10.3129 2.12656 10.3001 2.115L8.01488 0.03625C7.98875 0.0125 7.95437 0 7.91725 0C7.88012 0 7.84575 0.0125 7.81962 0.03625L1.991 5.335C1.97037 5.35375 1.958 5.37625 1.9525 5.40125L1.54688 7.50375C1.5335 7.57071 1.53828 7.63963 1.5608 7.70454C1.58332 7.76945 1.6229 7.82838 1.67612 7.87625C1.76687 7.95625 1.881 8 2.00338 8Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.d6eb8542.svg";
export { ForwardRef as ReactComponent };